import { useState, useEffect } from "react";
import LineupCardApi from "../httpClients/LineupCardApi";

const LOGO_TYPES = {
  TOP: "top",
  BOTTOM: "bottom",
  TEAM: "team",
};

const useGameLogos = ({ clubId, gamePk, otherOrgId, refreshKey } = {}) => {
  const [topLogo, setTopLogo] = useState(null);
  const [bottomLogo, setBottomLogo] = useState(null);
  const [teamLogo, setTeamLogo] = useState(null);
  const [otherOrgLogo, setOtherOrgLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!clubId || !gamePk) {
      setTopLogo(null);
      setBottomLogo(null);
      setTeamLogo(null);
      setOtherOrgLogo(null);
      return;
    }

    setLoading(true);

    const promises = [
      LineupCardApi.getLogoByClubIdAndGamePk(clubId, gamePk, LOGO_TYPES.TOP)
        .then(setTopLogo)
        .catch(() => setTopLogo(null)),
      LineupCardApi.getLogoByClubIdAndGamePk(clubId, gamePk, LOGO_TYPES.BOTTOM)
        .then(setBottomLogo)
        .catch(() => setBottomLogo(null)),
      LineupCardApi.getLogoByClubIdAndGamePk(clubId, gamePk, LOGO_TYPES.TEAM)
        .then(setTeamLogo)
        .catch(() => setTeamLogo(null)),
    ];

    if (otherOrgId) {
      promises.push(
        LineupCardApi.getLogoByClubIdAndGamePk(otherOrgId, gamePk, LOGO_TYPES.TEAM)
          .then(setOtherOrgLogo)
          .catch(() => setOtherOrgLogo(null)),
      );
    } else {
      setOtherOrgLogo(null);
    }

    Promise.all(promises).finally(() => setLoading(false));
  }, [clubId, gamePk, otherOrgId, refreshKey]);

  return { topLogo, bottomLogo, teamLogo, otherOrgLogo, loading };
};

export default useGameLogos;
